// extracted by mini-css-extract-plugin
export default {"chip":"tJYync"};